"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initCharts = exports.initChartEmbed = void 0;
/* eslint-disable */
/* this file was taken directly from the CMS */
const frontend_library_metrics_1 = require("@usafacts/frontend-library-metrics");
const cash_dom_1 = __importDefault(require("cash-dom"));
const query_string_1 = require("query-string");
const chartModifiers_1 = require("./chartModifiers");
function initChartEmbed() {
  const container = (0, cash_dom_1.default)('.chart__embed')[0];
  const containerSelector = (0, cash_dom_1.default)('.chart__embed');
  if (containerSelector.length > 0) {
    const model = new frontend_library_metrics_1.ChartModel([]);
    const chart = new frontend_library_metrics_1.Chart(container);
    let options = (0, query_string_1.parse)(location.search);
    // Convert metrics to the required format
    // Hashes, e.g. for hex colour vals must be %23
    options.metrics = JSON.parse(options.metrics);
    // Forward-fix chartFootnotes to drawFootnotes
    options.drawFootnotes = options.chartFootnotes || [];
    if (options.topMetrics) {
      options.topMetrics = JSON.parse(options.topMetrics);
    }
    // Parse other options from strings to their real type
    for (var key in options) {
      if (key == 'metrics' || key == 'topMetrics') {
        continue;
      }
      if (!options[key]) {
        delete options[key];
        continue;
      }
      if (options[key].hasOwnProperty('match') && options[key].match(/^\d/)) {
        options[key] = parseInt(options[key]);
      } else if (options[key] == 'true') {
        options[key] = true;
      } else if (options[key] == 'false') {
        options[key] = false;
      }
    }
    // Adds object properties.
    options = JSON.parse(JSON.stringify(options)); // need to inherit default object methods
    const chartData = model.getChartData(options, []);
    Promise.all([chartData.data, chartData.parent]).then(val => {
      chart.draw(chartData, options);
    }).catch(e => {
      console.warn(e);
    });
  }
}
exports.initChartEmbed = initChartEmbed;
function initCharts(adjustment, state) {
  const containers = (0, cash_dom_1.default)('.charts')[0];
  const containerSelectors = (0, cash_dom_1.default)('.charts');
  const model = new frontend_library_metrics_1.ChartModel([]);
  const isSotu = (0, cash_dom_1.default)('.sotu_topic, .sotu_landing, .sotu_base').length > 0 ? true : false;
  const params = (0, query_string_1.parse)(location.search);
  if (!adjustment && Object.keys(params).length > 0) {
    adjustment = params.adjustment;
  }
  if (!state && Object.keys(params).length > 0 && params.state) {
    if (Array.isArray(params.state)) {
      state = params.state;
    } else {
      state = [params.state];
    }
  }
  containerSelectors.each(function (item, index) {
    var _tableData;
    const chartContainer = (0, cash_dom_1.default)(this);
    const chart = new frontend_library_metrics_1.Chart(this); // Initialize (or re-initialize) chart.
    // Retrieve chart data from data attributes on template
    const title = chartContainer.attr('data-title');
    const subtitle = chartContainer.attr('data-subtitle');
    const rawoptions = eval('(' + chartContainer.attr('data-raw-options') + ')');
    let chartType = parseInt(chartContainer.attr('data-type'));
    const parentMetric = parseInt(chartContainer.attr('data-parent-metric'));
    const metric = parseInt(chartContainer.attr('data-metric'));
    const isEmbed = chartContainer.attr('data-embed');
    const baseUrl = chartContainer.attr('data-base-url');
    const showAllStates = chartContainer.attr('data-show-all-states') == 'true' ? true : false;
    const hideSources = chartContainer.attr('data-hide-sources');
    const extraFootnotes = eval('(' + chartContainer.attr('data-extra-footnotes') + ')');
    const extraSources = eval('(' + chartContainer.attr('data-extra-sources') + ')');
    let stateOptions = [];
    let extraMetrics = [];
    if (state) {
      if (state.length == 1 && state[0] == '00') {
        stateOptions = null;
      } else {
        stateOptions = state.filter(el => {
          if (el == '00') {
            extraMetrics.push({
              id: metric
            });
          }
          return el !== '00';
        }).map(el => {
          return {
            fips: el
          };
        });
      }
    }
    let options = {
      title: title || undefined,
      subtitle: subtitle || undefined,
      chartType: chartType,
      topMetrics: [...extraMetrics],
      metrics: [{
        id: metric
      }],
      adjustment: adjustment || null,
      chartFootnotes: extraFootnotes,
      chartSources: extraSources
    };
    if (parentMetric) {
      options.parentID = parentMetric;
    } else if (rawoptions) {
      options.parentID = rawoptions.metric;
    }
    if (parentMetric == metric && (!stateOptions || stateOptions.length === 0) && !showAllStates) {
      options['metrics'] = [{
        id: metric,
        labelText: ''
      }];
      options['showLegend'] = false;
      options['hideLineLabels'] = true;
    }
    if (chartType == 1 || state && state.length > 0) {
      // Chloropleth, load state data.
      if (state && state.length > 0) {
        if (state.length + extraMetrics.length > 3 && state.length + extraMetrics.length < 6) {
          chartType = 4;
          options['chartType'] = 4;
        } else if (state.length + extraMetrics.length >= 6) {
          chartType = 2;
          options['chartType'] = 2;
        } else {
          // Is a line chart, and has USA selected, so add the basic metric
          if (!showAllStates) {
            if (state.indexOf('00') > -1) {
              options['metrics'].push(...extraMetrics);
            }
          }
        }
        options.metrics[0].states = stateOptions;
      } else {
        options.metrics[0].allStates = true;
      }
    }
    if (chartType == 4) {
      // @NOTE: Have to fix the aspect ratio here for some reason.
      options = {
        ...options,
        heightToWidthRatio: 0.75
      };
    }
    if (isSotu) {
      // Default to use the SOTU API when on the SOTU pages.
      options['showLegend'] = false;
      options['showSourcesAndFootnotes'] = !hideSources;
    } else if (baseUrl) {
      options.source = baseUrl;
    }
    options = {
      ...options,
      ...rawoptions
    };
    if ((0, cash_dom_1.default)('body').hasClass('publication')) {
      // Overwrite autosize on publication charts, since this no longer works
      options['autosize'] = false;
    }
    // @TODO: Refactor this. Need to make sure the table uses the selected states,
    // while the chart sets allStates to true, but they're using the same call.
    let tableData;
    if (showAllStates) {
      tableData = model.getChartData(options, []); // Before we add all states.
      // Then supply the hardcoded settings.
      options.metrics[0].allStates = true;
      if (chartContainer.attr('id') == 'metric__state-dot-plot') {
        options.chartType = 2;
      }
      if (chartContainer.attr('id') == 'metric__state-map') {
        options.chartType = 1;
      }
    } else {
      tableData = false;
    }
    if (options.showUSA) {
      options.metrics = options.metrics.map(metric => ({
        ...metric,
        showUSA: true
      }));
    }
    const initialChartData = model.getChartData(options, []);
    if ((0, cash_dom_1.default)('body').hasClass('metric')) {
      // Metric page, initialize adjustments.
      if (initialChartData.parent) {
        initialChartData.parent.then(val => {
          (0, chartModifiers_1.initAdjustments)(val.metric);
        });
      }
    }
    Promise.resolve(initialChartData.data).then(val => {
      if ((0, cash_dom_1.default)('body').hasClass('metric') || (0, cash_dom_1.default)('.metric__meta-modal').length > 0) {
        let sources = [];
        let meta = [];
        for (const item of val) {
          if (item !== null && item !== void 0 && item.metric && item.metric.sources) {
            sources = [...sources, ...item.metric.sources];
          }
          if (item.metric && item.metric.datasets && item.metric.datasets[0] && item.metric.datasets[0].meta) {
            meta = [...meta, ...item.metric.datasets[0].meta];
          }
        }
        if (!(0, cash_dom_1.default)('body').hasClass('metric')) {
          (0, chartModifiers_1.initSotuSources)(chartContainer, sources, meta);
        }
      }
      // Just draw a basic chart with the initial data.
      chart.draw(initialChartData, options);
      chartContainer.removeClass('loading');
      (0, cash_dom_1.default)(chartContainer).parent().show();
      (0, cash_dom_1.default)(chartContainer).attr('data-options', JSON.stringify(options));
      (0, cash_dom_1.default)(chartContainer).parent().find('.chart-share-icons__download').off();
      (0, cash_dom_1.default)(chartContainer).parent().find('.chart-share-icons__download').on('click keypress', async function (e) {
        e.preventDefault();
        const canvas = await chart.drawCanvas(initialChartData, options, {}, undefined);
        const image = canvas.toDataURL('image/png');
        (0, cash_dom_1.default)(this).attr('href', image);
        (0, cash_dom_1.default)(this)[0].click();
        (0, cash_dom_1.default)(this).off();
      });
      if (isSotu) {
        chartContainer.find('.chart-loading').css('display', 'none');
      }
    }).catch(err => {
      if ((0, cash_dom_1.default)('body').hasClass('metric') || (0, cash_dom_1.default)('.metric__meta-modal').length > 0) {
        if (err.metric) {
          const sources = err.metric.sources ? err.metric.sources : [];
          const meta = err.metric.datasets && err.metric.datasets[0] && err.metric.datasets[0].meta ? err.metric.datasets[0].meta : [];
          if (!(0, cash_dom_1.default)('body').hasClass('metric')) {
            (0, chartModifiers_1.initSotuSources)(chartContainer, sources, meta);
          }
        }
      }
      if (err.metric && err.metric.children) {
        // Splat out the child metrics.
        let children = err.metric.children.map(item => {
          return {
            id: item
          };
        });
        // Including adjustments on child data as well.
        const childChartData = model.getChartData({
          parentID: parentMetric,
          metrics: children,
          adjustment: adjustment ? adjustment : null
        }, []);
        // Must check for empty data as adjustments may not be available.
        Promise.resolve(childChartData.data).then(val => {
          if (rawoptions && !rawoptions.hasOwnProperty('chartType')) {
            if (children.length > 3 && children.length < 6) {
              options['chartType'] = 4;
            } else if (children.length >= 6) {
              options['chartType'] = 2;
            }
          }
          chart.draw(childChartData, options);
          chartContainer.removeClass('loading');
          (0, cash_dom_1.default)(chartContainer).parent().show();
          let embedOptions = options;
          embedOptions['metrics'] = JSON.stringify(val.map(el => {
            return {
              id: el.id,
              fips: el.fips
            };
          }));
          (0, cash_dom_1.default)(chartContainer).attr('data-options', JSON.stringify(embedOptions));
          (0, cash_dom_1.default)(chartContainer).parent().find('.chart-share-icons__download').off();
          (0, cash_dom_1.default)(chartContainer).parent().find('.chart-share-icons__download').on('click keypress', async function (e) {
            e.preventDefault();
            const canvas = await chart.drawCanvas(childChartData, options, {}, undefined);
            const image = canvas.toDataURL('image/png');
            (0, cash_dom_1.default)(this).attr('href', image);
            (0, cash_dom_1.default)(this)[0].click();
            (0, cash_dom_1.default)(this).off();
          });
          if (isSotu) {
            chartContainer.find('.chart-loading').css('display', 'none');
          }
        }).catch(function (err) {
          // Hide the container if errors are present (e.g. data is missing).
          (0, cash_dom_1.default)(chartContainer).parent().hide();
          console.warn('Chart hidden due to error:', err);
        });
      } else {
        // Hide the container, because it's not a 'category' metric error.
        (0, cash_dom_1.default)(chartContainer).parent().hide();
      }
    });
    Promise.resolve(tableData ? (_tableData = tableData) === null || _tableData === void 0 ? void 0 : _tableData.data : initialChartData.data).then(values => {
      // add metric json to table container for table rendering.
      if (values) {
        if (state && state.length && values[0].id === parentMetric) {
          let datasets = [];
          const states = [];
          const newData = values[0];
          values.forEach(item => {
            if (!states.includes(item.fips)) {
              if (item.metric.datasets.length) {
                item.metric.datasets[0].name = item.metric.name;
                datasets = datasets.concat(item.metric.datasets[0]);
              } else {
                const nonDataObject = {};
                nonDataObject.name = item.metric.name;
                nonDataObject.id = item.fips;
                nonDataObject.geo_id = item.fips;
                datasets.push(nonDataObject);
              }
              states.push(item.fips);
            }
          });
          newData.metric.datasets = datasets;
          (0, cash_dom_1.default)('#metric-table-container').attr('data-states', JSON.stringify(states));
          (0, cash_dom_1.default)('#metric-table-container').attr('data-metric', JSON.stringify(newData.metric));
          datasets = [];
        } else {
          if (values.length === 1 && values[0].id === parentMetric) {
            (0, cash_dom_1.default)('#metric-table-container').attr('data-states', JSON.stringify([]));
            (0, cash_dom_1.default)('#metric-table-container').attr('data-metric', JSON.stringify(values[0].metric));
          }
        }
        const stateToggle = !!(state && state.length);
        (0, cash_dom_1.default)('#metric-table-container').attr('data-geo', JSON.stringify(stateToggle));
        if (!document.querySelectorAll('script[src="https://staticweb.usafacts.org/static/js/tables/index.js"]').length) {
          const tableScript = document.createElement('script');
          tableScript.type = 'text/javascript';
          tableScript.src = 'https://staticweb.usafacts.org/static/js/tables/index.js';
          (0, cash_dom_1.default)('head').append(tableScript);
        }
      }
    }).catch(e => {
      console.warn('Unknown Chart Error:', e);
    });
  });
}
exports.initCharts = initCharts;
function initAllCharts() {
  initCharts();
  initChartEmbed();
}
exports.default = initAllCharts;